import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/main.header.component';

class Artwork extends Component {
  render() {
    return (
      <div className="Artwork">
        <Header
          props={this.props}
        />
        <div className="art-body">
          <Link to='/artwork/moto' style={{ textDecoration: 'none'}}>
            <div id="art-text">
            <img src="/images/bikethumb.jpg" style={{ marginTop: '120px' }} id="art-image" alt=""/>
            always head west
            </div>
          </Link>
          <Link to='/artwork/complicity' style={{ textDecoration: 'none' }}>
          <div id="art-text">
          <img src="/images/complicitthumb.jpg" style={{ marginTop: '-10px' }} id="art-image" alt=""/>
            complicity
          </div>
          </Link>
          <Link to='/artwork/bigheads' style={{ color: 'white', textDecoration: 'none' }}>
            <div id="art-text">
            <img src="/images/bigheadsthumb.jpg" style={{ marginTop: '-140px' }} id="art-image" alt=""/>
              big heads
            </div>
          </Link>
          <Link to='/artwork/hawaii' style={{ textDecoration: 'none' }}>
          <div id="art-text">
          <img src="/images/marsthumb.jpg" style={{ marginTop: '-270px' }} id="art-image" alt=""/>
            Hawaiʻi
          </div>
          </Link>
          <Link to='/artwork/tintype' style={{ textDecoration: 'none' }}>
            <div id="art-text">
            <img src="/images/tintypethumb.jpg" style={{ marginTop: '-400px'}} id="art-image" alt=""/>
            Tintypes
            </div>
          </Link>
        </div>

      </div>
    );
  }
}


export default Artwork;
